// ============================================================
// EmptyState — No Data Placeholder
// ============================================================

import { Box, Typography, Button } from '@mui/material';
import { Inbox } from 'lucide-react';
import { tokens } from '@/theme/tokens';

export function EmptyState({
  icon: Icon = Inbox,
  title = 'No data found',
  message = 'There are no records to display at this time.',
  actionLabel,
  onAction,
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 8,
        px: 3,
        textAlign: 'center',
      }}
    >
      <Box
        sx={{
          width: 72,
          height: 72,
          borderRadius: tokens.radius.full,
          backgroundColor: tokens.colors.grey[100],
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 3,
        }}
      >
        <Icon size={32} color={tokens.colors.text.muted} />
      </Box>
      <Typography variant="h6" sx={{ mb: 1, color: tokens.colors.text.primary }}>
        {title}
      </Typography>
      <Typography
        variant="body2"
        sx={{ color: tokens.colors.text.muted, maxWidth: 400, mb: actionLabel ? 3 : 0 }}
      >
        {message}
      </Typography>
      {actionLabel && onAction && (
        <Button variant="contained" onClick={onAction}>
          {actionLabel}
        </Button>
      )}
    </Box>
  );
}
